if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const sectionIds = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [];
        if (this.cart) this.cart.setActiveElement(document.activeElement);
        config.body = formData;

        this.skipCart = this.form.querySelector('[name=id]')?.dataset.skipCart === 'true';

        // Open the drawer immediately — do not wait for Shopify to render HTML.
        if (!this.skipCart && this.cart?.openPending) {
          this.cart.openPending(this.submitButton);
        }

        this.addToCart(config, sectionIds)
          .then((response) => {
            if (response.status) {
              this.cart?.clearPending?.(true);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = '/checkout';
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.cart?.clearPending?.(true);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async addToCart(config, sectionIds) {
        // Only automatic upsells need to check whether the cart is empty.
        if (this.upsellVariantId) {
          const cartResponse = await fetch(`${routes.cart_url}.js`);
          if (!cartResponse.ok) throw new Error('Unable to read cart');
          const cartState = await cartResponse.json();
          if (cartState.item_count === 0) {
            await fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
          }
        }

        // JSON add only — rendering the drawer Liquid in this request is what made ATC feel slow.
        const addResponse = await fetch(`${routes.cart_add_url}`, config);
        const item = await addResponse.json();
        if (item.status || this.skipCart || !this.cart || !sectionIds.length) return item;

        const sectionResponse = await fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`);
        if (sectionResponse.ok) {
          item.sections = await sectionResponse.json();
        }
        if (!item.sections?.[sectionIds[0]]) {
          const htmlResponse = await fetch(`${routes.cart_url}?section_id=${sectionIds[0]}`);
          if (htmlResponse.ok) {
            item.sections = item.sections || {};
            item.sections[sectionIds[0]] = await htmlResponse.text();
          }
        }
        return item;
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
